import { render, staticRenderFns } from "./CardManutencaoSimplificado.vue?vue&type=template&id=b16f983c&scoped=true&"
import script from "./CardManutencaoSimplificado.vue?vue&type=script&lang=ts&"
export * from "./CardManutencaoSimplificado.vue?vue&type=script&lang=ts&"
import style0 from "./CardManutencaoSimplificado.vue?vue&type=style&index=0&id=b16f983c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16f983c",
  null
  
)

export default component.exports